module.exports = __webpack_public_path__ + "media/images/edion/en/top-4ee671a270a9d7131df6bdc815bc44f0.png";